import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 4,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    md: [
        {
            h: 4,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    xs: [
        {
            h: 4,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {},
    components: [
        {
            key: 'c1',
            name: 'user-selection',
            props: {
                isOpen: true,
            },
        },
    ],
};
